module.exports = __webpack_public_path__ + "static/mo27-7f184186f7c9389c90c25f0920060b74.png";